import axiosInstance from '@/core/api'
import type { components } from '@/schema'
import {
	GetEcsServiceCpuMemRequest,
	GetEcsServiceCpuMemResponse,
	GetTaskMetricsRequest,
	GetTaskMetricsResponse,
} from '../../type'

export const getEcsServiceCpuMem = async (
	params: GetEcsServiceCpuMemRequest,
): Promise<GetEcsServiceCpuMemResponse> => {
	const response = await axiosInstance.get<
		components['schemas']['GetEcsServiceCpuMemResponse']
	>('/admin/metrics/indicator-service-container', {
		params,
	})
	return response.data as GetEcsServiceCpuMemResponse
}

export const getTaskMetrics = async (
	params: GetTaskMetricsRequest,
): Promise<GetTaskMetricsResponse> => {
	const response = await axiosInstance.get<
		components['schemas']['GetTaskMetricsResponse']
	>('/admin/metrics/indicator-service-task', {
		params,
	})
	return response.data as GetTaskMetricsResponse
}
